/**
 * Format a number with apostrophe as thousands separator and customizable decimal places.
 * Returns '-' if the value is null or undefined.
 *
 * Examples:
 *   formatNumber(100000, 2) -> "100'000.00"
 *   formatNumber(43226.3442, 4) -> "43'226.3442"
 *   formatNumber(null, 2) -> "-"
 */
export const formatNumber = (
  value: number | null | undefined,
  suffix = '',
  decimals = 2,
): string => {
  if (value == null) return '-';

  const isNegative = value < 0;
  const absoluteValue = Math.abs(value).toFixed(decimals);
  const [intPart, decimalPart] = absoluteValue.split('.');

  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  const result = `${isNegative ? '-' : ''}${formattedInt}${decimals > 0 ? '.' + decimalPart : ''}${suffix}`;
  return result;
};
